// src/utils/group-eligibility.ts
var REQUIRED_GROUP_MEMBERS = 4;
function classifyGroupAction(action, ctx) {
  if (action === "stop") {
    return ctx.running ? { ok: true } : { ok: false, reason: "kh\xF4ng ch\u1EA1y" };
  }
  if (ctx.running) return { ok: false, reason: "\u0111ang ch\u1EA1y" };
  if (ctx.memberCount !== REQUIRED_GROUP_MEMBERS) {
    return { ok: false, reason: `c\u1EA7n \u0111\xFAng ${String(REQUIRED_GROUP_MEMBERS)} t\xE0i kho\u1EA3n` };
  }
  if (!ctx.allLoggedIn) return { ok: false, reason: "ch\u01B0a \u0111\u0103ng nh\u1EADp \u0111\u1EE7" };
  return { ok: true };
}

// src/utils/index.ts
function getTimestamp() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
function isProduction(env = process.env.NODE_ENV ?? "development") {
  return env === "production";
}
function decodeBase64(str) {
  if (typeof atob === "function") {
    return atob(str);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(str, "base64").toString("utf-8");
  }
  throw new Error("Base64 decoding is not supported in this environment");
}
function encodeBase64(str) {
  if (typeof btoa === "function") {
    return btoa(str);
  }
  if (typeof Buffer !== "undefined") {
    return Buffer.from(str, "utf-8").toString("base64");
  }
  throw new Error("Base64 encoding is not supported in this environment");
}
export {
  REQUIRED_GROUP_MEMBERS,
  classifyGroupAction,
  decodeBase64,
  encodeBase64,
  getTimestamp,
  isProduction,
  sleep
};
//# sourceMappingURL=index.js.map